import React, { useEffect, useState } from "react";
import Sidebar from "../../../sidebar/sidebar";
import Header from "../../../header/header";
import { injectKpiStyles } from "../../../DataManagment/Quantative/component/kpiStyles";
import KpiPageHeader from "../../../DataManagment/Quantative/component/KpiPageHeader";

/**
 * Page chrome aligned with DataManagment/Quantative (QuantativeList) layout.
 */
const SupplierManagementShell = ({
  pathname,
  pageTitle,
  totalCount = 0,
  actionsSlot = null,
  children,
}) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  useEffect(() => {
    injectKpiStyles();
  }, []);

  return (
    <div
      className="kpi-root"
      style={{
        display: "flex",
        background: "#f0f2f5",
        minHeight: "100vh",
        height: "100vh",
        fontFamily: "var(--font-sans)",
      }}
    >
      <div
        style={{
          flex: sidebarExpanded ? "0 0 21%" : "0 0 60px",
          position: "sticky",
          top: 0,
          height: "100vh",
          background: "var(--surface)",
          borderRight: "1px solid var(--rule)",
          zIndex: 100,
          transition: "flex 0.2s ease",
        }}
      >
        <Sidebar
          dataFromParent={pathname || "/supplier-management"}
          onSidebarToggle={(isOpen) => setSidebarExpanded(isOpen)}
        />
      </div>

      <main
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <Header />

        <KpiPageHeader
          pageTitle={pageTitle}
          selectedFY={null}
          totalCount={totalCount}
        />

        {actionsSlot ? (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 10,
              padding: "12px 24px 10px",
              borderBottom: "1px solid var(--rule-2)",
              background: "var(--surface)",
              flexShrink: 0,
            }}
          >
            {actionsSlot}
          </div>
        ) : null}

        <div
          className="supplier-mgmt-content"
          style={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
            padding: "16px 24px 28px",
          }}
        >
          {children}
        </div>
      </main>
    </div>
  );
};

export default SupplierManagementShell;
